import { render, staticRenderFns } from "./ParamTipoCarroceria.vue?vue&type=template&id=42d48bf4"
import script from "./ParamTipoCarroceria.vue?vue&type=script&lang=js"
export * from "./ParamTipoCarroceria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports